// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Avatar_avatarContainer__AckmJ","avatar":"Avatar_avatar__qs93d"};